/*
 * Copyright (c) 2016-2023 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
/**
 * Provides nessesary attributes for indicating a non-button element as an accessible button type.
 */
export function ariaButton() {
    return (target) => target.addInitializer((instance) => new AriaButtonController(instance));
}
export class AriaButtonController {
    constructor(host) {
        this.host = host;
        this.host.addController(this);
    }
    hostConnected() {
        this.host.tabIndex = 0; // initialize immediately so element can be focused synchronously
    }
    hostUpdated() {
        this.host.role = this.host.readonly ? null : 'button';
        this.host.tabIndex = !this.host.disabled ? 0 : -1;
        if (this.host.readonly) {
            this.host.removeAttribute('tabindex');
        }
    }
}
